import React from "react"
import "../../styles/all.scss"

const TabsContent = ({ children, moreClassNames = "" }) => (
  <div className={`columns ${moreClassNames}`}>
    <div className="column is-12">{children}</div>
  </div>
)
export default TabsContent
